import { Shelly } from './Shelly';
export const devices_config = {
	...Shelly,
};
